export default "TimeQuest opened back in 2013, making them the first and oldest escape room venue in Denmark.";